export function initialLedger(startingBalanceCents) {
    return { schemaVersion: 1, revision: 0, balanceCents: startingBalanceCents, positions: {}, receipts: {}, refills: {}, exposures: {}, samples: {}, conflicts: {}, entries: { 'initial-grant': { id: 'initial-grant', amountCents: startingBalanceCents, kind: 'grant' } } };
}
function assertLedger(value) {
    const candidate = value;
    if (!candidate || candidate.schemaVersion !== 1 || !Number.isSafeInteger(candidate.revision) || typeof candidate.balanceCents !== 'string' || !/^\d+$/.test(candidate.balanceCents) || !candidate.positions || !candidate.receipts || !candidate.refills || !candidate.exposures || !candidate.samples || !candidate.conflicts || !candidate.entries)
        throw new Error('Unsupported or damaged paper ledger; existing data was preserved.');
}
/** One aggregate record is the transaction boundary: all tabs mutate the same scope. */
export class LedgerStorage {
    factory;
    name;
    startingBalanceCents;
    ledgerKey;
    database;
    constructor(factory, name, startingBalanceCents, ledgerKey = 'ledger') {
        this.factory = factory;
        this.name = name;
        this.startingBalanceCents = startingBalanceCents;
        this.ledgerKey = ledgerKey;
    }
    async open() {
        if (this.database)
            return;
        if (!this.factory)
            throw new Error('Persistent browser storage is unavailable.');
        this.database = await new Promise((resolve, reject) => {
            const request = this.factory.open(this.name, 1);
            request.onupgradeneeded = () => { if (!request.result.objectStoreNames.contains('paper'))
                request.result.createObjectStore('paper'); };
            request.onsuccess = () => { const database = request.result; database.onversionchange = () => database.close(); resolve(database); };
            request.onerror = () => reject(request.error ?? new Error('Unable to open paper storage.'));
            request.onblocked = () => reject(new Error('Another page is preventing paper storage from opening.'));
        });
    }
    async mutate(change) {
        if (!this.database)
            throw new Error('Paper storage is not ready.');
        return new Promise((resolve, reject) => {
            const transaction = this.database.transaction('paper', 'readwrite');
            const store = transaction.objectStore('paper');
            const request = store.get(this.ledgerKey);
            let result;
            let caught;
            request.onsuccess = () => {
                try {
                    const absent = request.result === undefined;
                    const state = absent ? initialLedger(this.startingBalanceCents) : request.result;
                    assertLedger(state);
                    const outcome = change(state);
                    if (absent || outcome.changed) {
                        state.revision += 1;
                        store.put(state, this.ledgerKey);
                    }
                    result = { state, value: outcome.value };
                }
                catch (error) {
                    caught = error;
                    transaction.abort();
                }
            };
            transaction.oncomplete = () => result ? resolve(result) : reject(new Error('Paper transaction completed without a result.'));
            transaction.onabort = () => reject(caught ?? transaction.error ?? new Error('Paper storage transaction was aborted.'));
            transaction.onerror = () => { };
        });
    }
    close() { this.database?.close(); this.database = undefined; }
}
//# sourceMappingURL=storage.js.map